/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { colors, mixins } from '@blend/consumer-components';
import { Documents } from '../Documents/Documents';
import ClosingDocument from 'blb-components/common/Documents/ClosingDocument';
import { Scrollable } from '../Scrollable/Scrollable';
import { SidebarContent } from './SidebarContent';

const styles = StyleSheet.create({
  wrapper: {
    width: 274,
    height: '100%',
    display: 'flex',
    boxShadow: mixins.boxShadow(0, 4, 4, 0, mixins.fade(colors.black, 0.25)),
    overflowY: 'auto',
  },
});

export namespace Sidebar {
  export interface Props {
    documents: ClosingDocument[] | null;
    onSelectDocument: (doc: ClosingDocument) => void;
  }
}

export const Sidebar: React.FC<Sidebar.Props> = ({ documents, onSelectDocument }) => {
  return (
    <div className={css(styles.wrapper)} data-it="Sidebar">
      <SidebarContent title="Documents">
        <Scrollable>
          <Documents documents={documents} onSelectDocument={onSelectDocument} />
        </Scrollable>
      </SidebarContent>
    </div>
  );
};
